module.exports = __webpack_public_path__ + "static/fallback-header-ceb814e9468658c087ebff2b3a66dd74.png";